import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import classNames from "classnames";
import tinycolor from "tinycolor2";
import memoize from "lodash.memoize";

import { Client } from "resourceModels";
import { NO_OP_FUNCTION } from "services/helpers";
import { getResource } from "selectors/resources";
import "./styles.scss";
import * as S from "./styles";

const BLOCK_NAME = "ChatLogItem";

const getStyle = memoize(
  /** @param {Client} client */client => ({
    backgroundColor: client.tint,
    color: tinycolor(client.tint).isDark() ? "white" : null
  })
);

export class ChatLogItem extends React.PureComponent {
  /**
   * @returns {*}
   */
  render() {
    const {
      children,
      className,
      onClick,
      link,
      isFromUs,
      isLast,
      isLoading,
      isPicture,
      isSelected,
      hasEmojisOnly,
      hasReaction,
      client
    } = this.props;

    return (
      /* eslint-disable-next-line max-len */
      /* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
      <S.Root
        className={classNames(
          BLOCK_NAME, {
            [`${BLOCK_NAME}--us`]: isFromUs,
            [`${BLOCK_NAME}--them`]: !isFromUs,
            [`${BLOCK_NAME}--is-last`]: isLast,
            [`${BLOCK_NAME}--loading`]: isLoading,
            [`${BLOCK_NAME}--picture`]: isPicture,
            [`${BLOCK_NAME}--selected`]: isSelected,
            [`${BLOCK_NAME}--reaction`]: hasReaction,
            [`${BLOCK_NAME}--emojis`]: hasEmojisOnly,
            [className]: Boolean(className)
          }
        )}
        style={!isFromUs ? getStyle(client) : null}
        onClick={onClick}
      >
        <div className={`${BLOCK_NAME}__body`}>
          {children}

          {Boolean(link) && (
            <a
              className={`${BLOCK_NAME}__link`}
              href={link.href}
              onClick={link.onClick}
            >
              <div className={`${BLOCK_NAME}__link-preview`}>{link.preview}</div>
              <div className={`${BLOCK_NAME}__link-title`}>{link.title}</div>
            </a>
          )}
        </div>
      </S.Root>
    );
  }
}

ChatLogItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
  link: PropTypes.shape({
    href: PropTypes.string.isRequired,
    preview: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired
  }),
  isFromUs: PropTypes.bool,
  isLast: PropTypes.bool,
  isLoading: PropTypes.bool,
  isPicture: PropTypes.bool,
  isSelected: PropTypes.bool,
  hasEmojisOnly: PropTypes.bool,
  hasReaction: PropTypes.bool,

  client: PropTypes.instanceOf(Client).isRequired
};

ChatLogItem.defaultProps = {
  children: null,
  className: null,
  onClick: NO_OP_FUNCTION,
  link: null,
  isFromUs: false,
  isLast: false,
  isLoading: false,
  isPicture: false,
  isSelected: false,
  hasEmojisOnly: false,
  hasReaction: false
};

/**
 * @param {Object} state
 * @returns {Object}
 */
function mapStateToProps(state) {
  return {
    client: getResource(state, "client")
  };
}

const Connector = connect(mapStateToProps)(ChatLogItem);

Connector.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
  link: PropTypes.shape({
    href: PropTypes.string.isRequired,
    preview: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired
  }),
  isFromUs: PropTypes.bool,
  isLast: PropTypes.bool,
  isLoading: PropTypes.bool,
  isPicture: PropTypes.bool,
  isSelected: PropTypes.bool,
  hasEmojisOnly: PropTypes.bool,
  hasReaction: PropTypes.bool
};

export default Connector;
